import axios from "axios";

export interface WoodFrame {
  id: string | null;
  widthInMm: number;
  heightInMm: number;
  depthInMmFrom: number;
  feuerringFactor: number;
  priceNet: number;
  vat: number;
  perimeter: number;
  backPanelWithCutPrice: number;
  tray: boolean;
  backWall:boolean;
  partitionWall: boolean;
}

export interface FrameCalcResult {
  totalWeightInKg: number;
  priceGross: number;
  priceNet: number;
  vat: number;
  vatValue: number;
  feuerringFactor: number;
  feuerringFactorValue: number;
  backPanelWithCutPrice: number;
  customerPriceNet: number;
  customerPriceGross: number;
}

interface WoodFrameApi {
  list(): Promise<WoodFrame[]>;
  add(woodFrame: WoodFrame): Promise<WoodFrame>;
  edit(woodFrame: WoodFrame): Promise<WoodFrame>;
  delete(woodFrame: WoodFrame): Promise<void>;
  calc(perimeter: number, lengthInMm: number, heightInMm: number, depthInMm: number,  tray: boolean, partitionWall: boolean, backWall: boolean): Promise<FrameCalcResult>;
}

export const woodFrameApi: WoodFrameApi = {
  async list() {
    return (await axios.get("/api/calculations/wood-frames")).data;
  },
  async edit(woodFrame) {
    return await axios.put(`/api/calculations/wood-frames/${woodFrame.id}`, woodFrame);
  },
  async add(woodFrame) {
    return (await axios.post("/api/calculations/wood-frames", woodFrame)).data;
  },
  async delete(woodFrame) {
    return await axios.delete(`/api/calculations/wood-frames/${woodFrame.id}`);
  },
  async calc(perimeter, lengthInMm, heightInMm,depthInMm,tray, partitionWall, backWall) {
    return (await axios.get(`/api/calculations/wood-frames/calc?perimeter=${perimeter}&lengthInMm=${lengthInMm}&heightInMm=${heightInMm}&depthInMm=${depthInMm}&tray=${tray}&partitionWall=${partitionWall}&backWall=${backWall}`)).data;
  },
}; 